module.exports = __webpack_public_path__ + "img/bg-color.3348bb3.55cdcefe.png";